
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.673 0h-10.4c-1.52 0-2.8 1.28-2.8 2.8v10.4c0 1.52 1.28 2.8 2.8 2.8h8.4l4.8-4.8V2.8c0-1.52-1.28-2.8-2.8-2.8zm1.28 10.4h-1.2c-1.52 0-2.8 1.28-2.8 2.8v1.2h-7.44c-.8 0-1.44-.64-1.44-1.44V3.04c0-.8.64-1.44 1.44-1.44h10c.8 0 1.44.64 1.44 1.44v7.36zM4.473 4h8v1.6h-8V4zm0 3.2h8v1.6h-8V7.2zm0 3.2h4.8V12h-4.8v-1.6z","fill":"#B7BEC5"}})])
          )
        }
      }
    